// // src/line/pages/OpenInLine.jsx
// import React from 'react';
// import '../styles/line.css';

// // Vite/CRA 両対応の安全なenv読み取り
// const viteEnv = (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : {};
// const env = { ...process.env, ...viteEnv };

// const liffId = env.VITE_LINE_LIFF_ID || env.REACT_APP_LINE_LIFF_ID || '';
// const officialId = env.VITE_LINE_OFFICIAL_ID || env.REACT_APP_LINE_OFFICIAL_ID || '';

// export default function OpenInLine() {
//   const liffUrl = liffId ? `https://liff.line.me/${liffId}` : null;
//   const officialUrl = officialId ? `https://line.me/R/ti/p/@${officialId}` : null;

//   return (
//     <div className="line-container">
//       <div className="menu-wait-wrapper">
//         <div className="menu-wait-outer">
//           <div className="wait-text">
//             <p>
//               このページは<br /><b>LINEアプリから</b>ご利用ください
//             </p>
//           </div>
//         </div>
//       </div>

//       <div className="menu-wrapper">
//         <div className="menu-outer">
//           {liffUrl && (
//             <a href={liffUrl} className="menu-btn" style={{ textDecoration: 'none' }}>
//               LINEで開く（LIFF）
//             </a>
//           )}
//           {!liffUrl && officialUrl && (
//             <a href={officialUrl} className="menu-btn" style={{ textDecoration: 'none' }}>
//               公式アカウントを開く
//             </a>
//           )}
//           {!liffUrl && !officialUrl && (
//             <div className="muted" style={{ fontSize: '3rem', textAlign: 'center' }}>
//               LINEアプリ内のメニューから「予約」を開いてください。
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// src/line/pages/OpenInLine.jsx
import React, { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/line.css';

// Vite / CRA 両対応で env を読む
const viteEnv = (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : {};
const env = { ...process.env, ...viteEnv };

// 3種の LIFF ID（存在しないものは空でOK）
const LIFF_IDS = {
  book: env.VITE_LINE_LIFF_ID_BOOK || env.REACT_APP_LINE_LIFF_ID_BOOK || '',
  all:  env.VITE_LINE_LIFF_ID_ALL  || env.REACT_APP_LINE_LIFF_ID_ALL  || '',
  my:   env.VITE_LINE_LIFF_ID_MY   || env.REACT_APP_LINE_LIFF_ID_MY   || '',
  // デフォルト（どれにもマッチしなければ使う）
  default: env.VITE_LINE_LIFF_ID || env.REACT_APP_LINE_LIFF_ID || '',
};

// 公式アカへ飛ばす導線（任意）
const OFFICIAL_ID = env.VITE_LINE_OFFICIAL_ID || env.REACT_APP_LINE_OFFICIAL_ID || '';

const labelMap = {
  book: '受付番号予約をLINEで開く',
  all:  '予約一覧をLINEで開く',
  my:   'マイ予約をLINEで開く',
};

export default function OpenInLine() {
  const { search } = useLocation();
  const [dest, setDest] = useState('book'); // 初期は予約

  // /open-in-line?to=/book | /all | /my | /reservation
  useMemo(() => {
    const q = new URLSearchParams(search);
    const raw = (q.get('to') || '/book').replace(/^\/+/, ''); // 'book'
    // /reservation は my と同等に扱う
    const normalized = ['book', 'all', 'my', 'reservation'].includes(raw) ? (raw === 'reservation' ? 'my' : raw) : 'book';
    setDest(normalized);
  }, [search]);

  const liffId =
    (dest === 'book' && LIFF_IDS.book) ||
    (dest === 'all'  && LIFF_IDS.all)  ||
    (dest === 'my'   && LIFF_IDS.my)   ||
    LIFF_IDS.default;

  const liffUrl = liffId ? `https://liff.line.me/${liffId}` : null;
  const officialUrl = OFFICIAL_ID ? `https://line.me/R/ti/p/@${OFFICIAL_ID}` : null;

  return (
    <div className="line-container">
      <div className="menu-wait-wrapper">
        <div className="menu-wait-outer">
          <div className="wait-text">
            <p>
              このページは<br /><b>LINEアプリから</b>ご利用ください
            </p>
          </div>
        </div>
      </div>

      <div className="menu-wrapper">
        <div className="menu-outer">
          {liffUrl ? (
            <a href={liffUrl} className="menu-btn" style={{ textDecoration: 'none' }}>
              {labelMap[dest] || 'LINEで開く（LIFF）'}
            </a>
          ) : officialUrl ? (
            <a href={officialUrl} className="menu-btn" style={{ textDecoration: 'none' }}>
              公式アカウントを開く
            </a>
          ) : (
            <div className="muted" style={{ fontSize: '3rem', textAlign: 'center' }}>
              LINEアプリ内のメニューから対象ページを開いてください。
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
